import { FinalSteps } from "../../components/common/create-profile/expenses";
import CreateProfileCenterWrapper from "../../components/common/CreateProfileCenterWrapper";
import CreateProfileHeader from "../../components/common/CreateProfileHeader";
import CreateProfileLayout from "../layout";

export default function Report() {
  return (
    <CreateProfileLayout>
      <div className="income-details-right previous-hidden">
        <CreateProfileHeader handlePreviousStep={() => {}} step={0} />
        <CreateProfileCenterWrapper className={"is-final"}>
          <FinalSteps />
        </CreateProfileCenterWrapper>
      </div>
    </CreateProfileLayout>
  );
}
